module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/165.13a90c3a.png";